/* global location */
import './styles.scss'

import I18n from 'lib/i18n'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'kea'

import Tooltip from 'rc-tooltip'

import Rating from '~/scenes/shared/rating'
import Price from 'lib/tags/price'
import Imgix from 'lib/tags/imgix'
import railsContext from 'lib/selectors/rails-context'

import distanceFromLatLonInKm from 'lib/utils/geo/distance-from-lat-lon-in-km'

import Reputation from './reputation'

@connect({
  props: [railsContext, ['featureFlags']]
})
export default class Result extends Component {
  static propTypes = {
    result: PropTypes.object.isRequired,
    center: PropTypes.array,
    isFavourite: PropTypes.bool,
    isHovering: PropTypes.bool,
    settingFavourite: PropTypes.bool,
    showFullLocation: PropTypes.bool,
    locale: PropTypes.string,
    dpr: PropTypes.number
  }

  constructor (props, context) {
    super(props, context)

    this.state = {
      favouriteChanged: false
    }
  }

  shouldComponentUpdate (nextProps) {
    return (
      this.props.result !== nextProps.result ||
      this.props.center !== nextProps.center ||
      this.props.isFavourite !== nextProps.isFavourite ||
      this.props.isHovering !== nextProps.isHovering ||
      this.props.settingFavourite !== nextProps.settingFavourite ||
      this.props.showFullLocation !== nextProps.showFullLocation ||
      this.props.locale !== nextProps.locale
    )
  }

  onMouseEnter = e => {
    const { result, hoverResult } = this.props
    hoverResult(result)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.isFavourite !== this.props.isFavourite) {
      this.setState({
        favouriteChanged: true
      })
    }
  }

  onMouseLeave = e => {
    const { hoverResult } = this.props
    hoverResult(null)
  }

  onClick = e => {
    const { result } = this.props
    const url = result.path

    e.preventDefault()

    location.href = url
  }

  toggleFavourite = e => {
    const { result, isFavourite, setFavourite, removeFavourite } = this.props

    e.preventDefault()

    if (isFavourite) {
      removeFavourite(result)
    } else {
      setFavourite(result)
    }
  }

  handleTranslate = e => {
    const { result, locale, translateResultRequest } = this.props

    e.preventDefault()
    translateResultRequest(result.id, result.translated ? null : locale)
  }

  render () {
    const {
      result,
      center,
      isHovering,
      isFavourite,
      showFullLocation,
      locale,
      settingFavourite,
      dpr,
      score,
      featureFlags: { isAdminUser },
      openVideo
    } = this.props
    const { favouriteChanged } = this.state
    const showTranslate = result.language !== locale || result.translated

    const path = `${result.path}?from_landing_page=true`

    let fullLocationString = result.location_string
    let minDistance = null

    result.locations.forEach(location => {
      const distance = center
        ? distanceFromLatLonInKm(location.latitude, location.longitude, center[0], center[1])
        : null

      if (distance && (minDistance === null || distance < minDistance)) {
        minDistance = distance
        fullLocationString = location.long_city
      }
    })

    const locationString = fullLocationString ? fullLocationString.replace(/,[^,]+$/, '').trim() : null

    const tags = []
    let i = 0
    result.tags.forEach(tag => {
      if (tags.length > 0) {
        tags.push(<span key={i++}> · </span>)
      }
      tags.push(<span key={i++}>{tag}</span>)
    })

    return (
      <div
        id={`result-${result.id}`}
        className={`search-result${isHovering ? ' hover' : ''}`}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div className='result-content'>
          <div className='image' onClick={() => window.open(path, '_blank')}>
            {result.user_video_url ? (
              <div className='play-btn-container'>
                <div className='play-btn' />
              </div>
            ) : null}
            <Imgix src={result.avatar} width={150} alt={result.title} dpr={dpr} lazyLoad />
            {result.verified ? <Reputation id={result.user_id} /> : null}
          </div>
          <div className='responsive-image'>
            <a href={path} target='_blank' aria-label={result.title} rel='noreferrer'>
              <Imgix src={result.avatar} width={70} alt={result.title} dpr={dpr} />
              {result.verified ? <Reputation id={result.user_id} /> : null}
            </a>
          </div>
          <div className='text'>
            <div className={`name-rating-row ${result.boosted && 'name-rating-row-boosted-sbp'}`}>
              {result.rating ? (
                <div className='right'>
                  <Rating rating={result.rating / 20.0} dpr={dpr} />
                  <span className='num-reviews'>
                    {I18n.t('react.search.result.reviews', { count: result.reviews })}
                  </span>
                </div>
              ) : null}
              <a href={path} className='name' target='_blank' rel='noreferrer'>
                <span>
                  {result.name}
                  {locationString && (
                    <span className='user-location'> - {showFullLocation ? fullLocationString : locationString}</span>
                  )}
                </span>

                {result.boosted && (
                  <span className='boosted-course-tag'>{I18n.t('react.search.result.recently_active')}</span>
                )}
              </a>
              <span className='name-rating-price'>
                <Price currency={result.currency} price={Math.round(result.price_number)} />
              </span>
            </div>
            <div className='title-price-row'>
              <div className='title-price-inner'>
                <span className='price'>
                  <Price currency={result.currency} price={Math.round(result.price_number)} />
                </span>
                <a className='title-link' href={path} target='_blank' rel='noreferrer'>
                  <span className='title'>{result.title}</span>
                </a>
              </div>
            </div>
            <div className='result-content'>
              <a href={path} target='_blank' rel='noreferrer'>
                {result.premium ? (
                  <span className='premium-teacher'>{I18n.t('react.search.result.premium_teacher')} </span>
                ) : (
                  ''
                )}
                <span>{result.description}</span>
              </a>
            </div>
            <div className='result-tags'>{tags}</div>
            {isAdminUser && <div className='user-ranking'>score: {score}</div>}
          </div>
          <div className='props'>
            <div
              className={`heart${favouriteChanged ? ' changed' : ''}${isFavourite ? ' active' : ' inactive'}`}
              style={{ cursor: settingFavourite ? 'wait' : 'pointer' }}
              onClick={this.toggleFavourite}
            />
            {showTranslate ? (
              <Tooltip
                key={result.translated ? 'translated-tooltip' : 'translate-tooltip'}
                placement='left'
                trigger={['hover']}
                overlay={
                  result.translated
                    ? I18n.t('jstemplates.searchresult.translated')
                    : I18n.t('jstemplates.searchresult.translate')
                }
              >
                <a className='translate' href='#' onClick={this.handleTranslate}>
                  {I18n.t('jstemplates.searchresult.translate')}
                </a>
              </Tooltip>
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}
